<template>
<div>
  <button
    id="googleLoginButton"
    class="google-login-btn"
    :class="{border: showBorder}"
    @click="click"
  >
    <img src="/img/icons/google.png" alt="Google logo">
    <span v-if="isLogin">Sign in with Google</span>
    <span v-else>Sign up with Google</span>
  </button>
</div>
</template>

<script>
export default {
  props: {
    scope: {
      type: String,
      default: 'profile email',
    },
    width: {
      type: Number,
      default: 240,
    },
    height: {
      type: Number,
      default: 50,
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    googleClientID: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  }),

  mounted() {
    window.handleCredentialResponse = this.handleCredentialResponse;
    this.initializeGoogleButton();
  },

  methods: {
    handleCredentialResponse(response) {
      const responsePayload = response.credential;
      this.$emit('success', responsePayload);
    },
    initializeGoogleButton() {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: this.googleClientID,
          callback: this.handleCredentialResponse,
        });
        window.google.accounts.id.renderButton(
          document.getElementById('g_id_onload'),
          { theme: 'outline', size: 'large' },
        );
      }
    },
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
#googleLoginButton {
  border-radius: 100px;
  background-color: #fff;
  color: #111;
  font-size: 22px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  &.border {
    border: 1px solid $baseColor;
  }
  img {
    height: 26px;
    margin-right: 10px;
  }
}
</style>
